import { gql } from '@apollo/client';

export const DELETE_CREDENTIALS_MEMPHIS = gql`
  mutation DeleteMemphisCredentials($storeId: ID!) {
    deleteMemphisCredentials(storeId: $storeId) {
      ... on DeleteMemphisCredentialsSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
